import { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import * as styles from "./CardMinimal.css";
import { Heading } from "~/components/elements/Heading";
import PortableText, {
  IPortableText,
} from "~/components/portableText/PortableText";
import { ButtonLink } from "~/components/elements/ButtonLink";
import { IImage, Image } from "~/components/elements/Image";
// @ts-ignore
import ArrowOutward from "@material-design-icons/svg/filled/arrow_outward.svg?react";
import { Paragraph } from "~/components/elements/Paragraph";
import { Link as ILink } from "~/sanity/types";

export type CardMinimalProps = ComponentPropsWithoutRef<"div"> &
  PropsWithChildren & {
    card: {
      title?: string;
      subtitle?: string;
      text?: IPortableText | string;
      link?: ILink;
      image?: IImage;
    };
    theme?: "light" | "dark";
  };

export const CardMinimal = ({
  card,
  theme = "dark",
  className,
  ...props
}: CardMinimalProps) => {
  const { title, subtitle, text, link, image } = card;

  return (
    <div className={styles.card({ theme: theme })}>
      {image && (
        <div className={styles.imageContainer}>
          <Image
            image={image}
            width={500}
            loading="eager"
            className={styles.image}
          />
        </div>
      )}
      <div className={styles.content}>
        {title && (
          <Heading as="h3" size="h3" uppercase bold>
            {title}
          </Heading>
        )}
        {subtitle && (
          <Paragraph size="sm" bold>
            {subtitle}
          </Paragraph>
        )}
        {text && typeof text === "string" ? (
          <Paragraph size="sm">{text}</Paragraph>
        ) : (
          <PortableText blocks={text} truncateLength={120} />
        )}
        {link && link.slug && (
          <div className={styles.link}>
            <ButtonLink
              theme={theme === "light" ? "light" : "colour"}
              isPrimary={false}
              link={link}
              icons={{ iconPrimary: <ArrowOutward /> }}
            >
              {link.text}
            </ButtonLink>
          </div>
        )}
      </div>
    </div>
  );
};
